import { render, staticRenderFns } from "./Forbidden.vue?vue&type=template&id=4d0bef48"
import script from "./Forbidden.vue?vue&type=script&lang=ts"
export * from "./Forbidden.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports